/* eslint-disable max-len */
export const checkIsEmpty = (obj: any) => {
  const isEmpty = obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;

  return isEmpty;
};

export const validateEmail = (value: string) =>
  String(value)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

export const formatAmount = (amount: number) => {
  const price = new Intl.NumberFormat('en-EN', { style: 'currency', currency: 'USD' }).format(amount / 100);

  return price;
};

export const hex2rgba = (hex: string, alpha = 1) => {
  // @ts-ignore
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const isIos = () =>
  ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

export const canShare = () => {
  const mockFile = new File([new Blob()], 'brush.zip', {
    type: 'application/zip',
  });

  return navigator.canShare && navigator.canShare({ files: [mockFile] });
};
